import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { API_URL } from '@/config';


interface MagicLinkVerifyResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
  user: {
    id: string;
    email: string;
    username?: string;
    full_name?: string;
    role: string;
    organization_id: string;
    is_active: boolean;
    avatar_url?: string;
    github_id?: string;
    github_connected?: boolean;
    created_at: string;
    updated_at: string;
  };
}

export function MagicLinkCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleCallback = async () => {
      const token = searchParams.get('token');

      if (!token) {
        navigate('/login?error=missing_token', { replace: true });
        return;
      }

      try {
        const response = await fetch(`${API_URL}/api/v1/auth/magic-link/verify`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });

        if (!response.ok) {
          navigate('/login?error=invalid_magic_link', { replace: true });
          return;
        }

        const data: MagicLinkVerifyResponse = await response.json();

        useAuthStore.setState({
          token: data.access_token,
          refreshToken: data.refresh_token,
          tokens: {
            access_token: data.access_token,
            refresh_token: data.refresh_token,
            token_type: data.token_type || 'bearer',
            expires_in: data.expires_in || 3600,
          },
          user: data.user,
          isAuthenticated: true,
        });

        navigate('/dashboard', { replace: true });
      } catch (error) {
        console.error('Magic link verification failed:', error);
        navigate('/login?error=invalid_magic_link', { replace: true });
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
        <p className="mt-4 text-gray-400">Signing you in...</p>
      </div>
    </div>
  );
}
